import sdk from '@psp-aggregator/sdk';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface UseRegistrationInvitesParams {
  enabled?: boolean;
  limit?: number;
  page?: number;
}

export const useRegistrationInvites = ({
  enabled = true,
  limit,
  page,
}: UseRegistrationInvitesParams = {}) =>
  sdk.queries.useListRegistrationInvites(page, limit, { enabled });

export const useCreateRegistrationInvite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => sdk.requests.createRegistrationInvite(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['listRegistrationInvites'],
      });
    },
  });
};
